export default __webpack_public_path__ + "static/media/analytics.6702d87e.svg";